<template>
    <div id="app">
        <component :is="layout"><router-view /></component>
    </div>
</template>

<script>
import { authenticationService } from '@/services';

const default_layout = 'default';

export default {
    data() {
        return {
            currentUser: null,
        };
    },
    computed: {
        layout() {
            const meta = this.$route.meta.layout || default_layout;
            return `${meta}_layout`;
        },
    },
    created() {
        authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
    },
};
</script>

<style lang="scss">
@font-face {
    font-family: 'Nunito';
    src: url(./assets/fonts/Nunito-Regular.ttf) format('truetype');
}
#app {
    font-family: 'Nunito', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
    width: 100vw;
    height: 100vh;

    font-size: 13px;
    line-height: 18px;
}

// #nav {
//     padding: 30px;
// }

// #nav a {
//     font-weight: bold;
//     color: #2c3e50;
// }

// #nav a.router-link-exact-active {
//     color: #42b983;
// }
.form-title {
    padding: 48px; //Opx 45px 0px 45px;
    color: #2a2a2a;
    // font-family: "Avenir Next";
    font-size: 19px;
    font-weight: 600;
    line-height: 26px;
    text-align: center;
}

.form-control {
    padding: 0px 35px 20px;
    // display: flex;

    label {
        color: #2a2a2a;
        // font-family: "Avenir Next";
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
    }

    .input,
    .textarea,
    .dropdown {
        margin-top: 9px;
    }

    &.form-inline {
        // display: inline-flex;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        //justify-content: space-between;
    }
}
</style>
